//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DirUtil } from "@nuskin/ns-util";
import NsSearchbarTooltip from "./NsSearchbarTooltip.vue";

export default {
  name: "NsSearchbarButton",
  components: { NsSearchbarTooltip },
  props: {
    translations: {
      type: Object,
      default: function() {
        return {};
      }
    },
    focused: Boolean,
    newHeader: Boolean,
    showTooltip: Boolean,
    submitButtonActive: Boolean
  },
  computed: {
    dir() {
      return DirUtil.getDir();
    }
  }
};
